import { render, staticRenderFns } from "./event_trend.vue?vue&type=template&id=21ff4bed&scoped=true"
import script from "./event_trend.vue?vue&type=script&lang=js"
export * from "./event_trend.vue?vue&type=script&lang=js"
import style0 from "./event_trend.vue?vue&type=style&index=0&id=21ff4bed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ff4bed",
  null
  
)

export default component.exports